import { Fragment } from 'react';

export const AddOrderContainer = Fragment;
